import { useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';

/**
 * "Edit" on an Overview panel, pointing at that section's own form.
 *
 * These panels DISPLAY a section, so the obvious place to change it is right
 * there — reaching the section forms only through the onboarding checklist made
 * them findable exactly once, when the checklist happened to mention them.
 *
 * The panels are shared between the admin and industry apps, so the link is
 * role-aware; both now route the same four section forms.
 */
export default function SectionEditLink({ section }) {
  const listing = useSelector((s) => s.listings.selected);
  const user = useSelector((s) => s.auth.user);

  if (!listing?.id || !section) return null;

  const role = user?.role === 'admin' ? 'admin' : 'industry';

  return (
    <NavLink
      to={`/${role}/listings/${listing.id}/edit/${section}`}
      className="text-sm font-medium text-red-800 hover:underline shrink-0"
    >
      Edit
    </NavLink>
  );
}
